import { html, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';

import { styles as globalStyles } from '~/ui/scss/main.styles';
import { styles } from './accordion.styles';

import { DERElement } from '~/common/der-element';
import '~/ui/objects/image-grid/image-grid.component';
import { SvgUtility } from '~/ui/utils';

export class Accordion extends DERElement {
    static override styles = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    @property({ type: String }) override title = '';
    @property({ type: Boolean, reflect: true }) open: boolean = false;
    @property({ type: Array }) images: string[] = [];

    private toggleOpen = () => {
        this.open = !this.open;
    };

    protected override render() {
        return html`
            <div class="c-accordion">
                <button class="c-accordion__header" @click=${this.toggleOpen} aria-expanded="${this.open}">
                    <h2 class="c-accordion__title">${this.title}</h2>
                    <span class="c-accordion__indicator">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 40 40" fill="none">
                            ${this.open ? SvgUtility.systemMinus : SvgUtility.systemPlus}
                        </svg>
                    </span>
                </button>
                <div class="c-accordion__panel" ?hidden=${!this.open}>
                    <slot></slot>
                </div>
            </div>
        `;
    }
}
